const uuidPart = (length: number) => {
  let result = '';
  const characters = 'abcdef0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateUuid = () => {
  if ('crypto' in window && 'randomUUID' in window.crypto) {
    return window.crypto.randomUUID();
  }
  return uuidPart(8) + '-' + uuidPart(4) + '-' + uuidPart(4) + '-' + uuidPart(4) + '-' + uuidPart(12);
};
